import React from 'react'

import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import useStyles from './styles'

export default function StandardsHead({context}) {

  const classes = useStyles()
  const {translate, standardsContext} = context
  const {assessmentIndicators} = standardsContext 

  const hasIndicators = Object.keys(assessmentIndicators).length > 0 || false;

  const headCells = [
    { id:  hasIndicators ? 'indicator' : 'expectation', align: 'center', disablePadding: false, hide: false},
    { id: 'questions', align: 'center', disablePadding: false, hide: false},
    { id: 'percent', align: 'center', disablePadding: false, hide: false},
    { id: 'status', align: 'center', disablePadding: false, hide: false}
  ];

  return (
        <TableHead>
            <TableRow className={classes.tableHeader}>
                {headCells.map(({id, align, disablePadding, hide}) => (
                <TableCell
                    key={id}
                    align={align}
                    padding={disablePadding ? 'none' : 'normal'}
                >
                    { !hide ? translate(`${id}-header`) : ''}
                </TableCell>
                ))}
            </TableRow>
        </TableHead>
  )
}
